import { Injectable } from "@angular/core";
import { Storage } from '@ionic/storage';
import { NestApiProvider } from "../../../shared/nestjs/nest-api"; // Need Dependency - PageBuilder
import { ApiServiceProvider } from "../api/api-service";
import { PageBuilderMenuProvider } from "../menu/repository";

/**
   * Crated by Hendi, 23 Jan 2020.
  */
@Injectable()
export class PageBuilderFeaturePageProvider {
    private FEATURE_KEY = 'GDPageFeature'
    private chanceCounter = 0;
    private isLoading = false;

    constructor(
        private nestApiProvider: NestApiProvider,
        private storage: Storage,
        private apiServiceProvider: ApiServiceProvider,
        private pageBuilderMenuProvider: PageBuilderMenuProvider,
    ) { }

    async getPageFeatureByCode(featureCode: string): Promise<any> {
        return new Promise(async (resolve) => {
            console.log('TCL: FeaturePage: ');
            if (this.isLoading) {
                // console.log("TCL: FeaturePage: isLoading:", this.isLoading);
                return;
            }

            this.isLoading = true;

            try {
                let collection = await this.getFeaturePageCollection();
                console.log("TCL: FeaturePage: stored collection data:", collection);
                if (collection) {
                    let pageFeature = this.getPageFeature(featureCode, collection);
                    if (pageFeature) {
                        // console.log("TCL: FeaturePage: return stored data:", pageFeature);
                        resolve(pageFeature);
                        this.isLoading = false;
                    } else {
                        // console.log("TCL: FeaturePage: chanceCounter:", this.chanceCounter);
                        // force reload from server once
                        if (this.chanceCounter == 0) {
                            this.chanceCounter++;
                            // console.log("TCL: FeaturePage: chanceCounter execute:", this.chanceCounter);
                            let remoteCollection = await this.getRemoteFeaturePageCollection();
                            let remotePageFeature = this.getPageFeature(featureCode, remoteCollection);
                            if (remotePageFeature) {
                                // console.log("TCL: FeaturePage: return remote data:", remotePageFeature);
                                resolve(remotePageFeature);
                            }
                            this.isLoading = false;
                        } else {
                            this.isLoading = false;
                        }
                    }
                } else {
                    let remoteCollection = await this.getRemoteFeaturePageCollection();
                    let remotePageFeature = this.getPageFeature(featureCode, remoteCollection);
                    if (remotePageFeature) {
                        // console.log("TCL: FeaturePage: return remote data:", remotePageFeature);
                        resolve(remotePageFeature);
                    }
                    this.isLoading = false;
                }
            } catch (error) {
                this.isLoading = false;
            }
        });
    }

    private getFeaturePageCollection(): Promise<any> {
        return new Promise((resolve) => {
            this.storage.ready().then(() => {
                this.storage.get(this.FEATURE_KEY)
                    .then(collectionStr => {
                        try {
                            let collection = JSON.parse(collectionStr);
                            resolve(collection);
                        } catch (error) { }
                    })
            });
        });
    }

    private getPageFeature(featureCode: string, collection: any): any {
        let page = collection.find(item => item.code == featureCode);
        return page;
    }

    private getRemoteFeaturePageCollection(): Promise<any> {
        return new Promise(async (resolve) => {
            console.log('isGoPathNewExist');
            let isGoPathNewExist = await this.nestApiProvider.isGoPathNewExist();
            if (isGoPathNewExist) {
                // console.log("TCL: FeaturePage: load from remote nest");
                this.getRemoteFeaturePageCollectionNest().then(
                    results => {
                        // console.log("TCL: FeaturePage: load from remote nest success", results);
                        this.storage.set(this.FEATURE_KEY, JSON.stringify(results.data));
                        resolve(results.data);
                    }, error => {
                        // console.log("TCL: FeaturePage: load from remote nest error", error);
                    }
                )
            } else {
                // console.log("TCL: FeaturePage: load from remote loopback");
                this.getRemoteFeaturePageCollectionLoopback().then(
                    results => {
                        // console.log("TCL: FeaturePage: load from remote loopback success", results);
                        this.storage.set(this.FEATURE_KEY, JSON.stringify(results.data));
                        resolve(results.data);
                    }, error => {
                        // console.log("TCL: FeaturePage: load from remote loopback error", error);
                    }
                )
            }
        });
    }

    private async getRemoteFeaturePageCollectionNest(): Promise<any> {
        const UserData = await this.pageBuilderMenuProvider.getUserData();
        const bodyAuth = {
            auth: {
                userData: {
                    companyId: UserData.companyId,
                    isSF6: UserData.isSF6,
                },
            },
        }
        const urlBody = JSON.stringify(bodyAuth);
        const encryptedBody = await this.apiServiceProvider.sfEncrypt(urlBody);

        return new Promise((resolve, reject) => {
            this.apiServiceProvider.apiPB('GET', null, null, '/app-feature/getFeaturePage', false, true, encryptedBody).then(
                async res => {
                    resolve(res)
                }, err => {
                    reject(err)
                })
        })
    }

    private getRemoteFeaturePageCollectionLoopback(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiServiceProvider.apiPB('GET', null, null, '/app-feature/getFeaturePage', false, true).then(async (response: any) => {
                resolve(response);
            }, error => {
                reject(error);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/pagebuilder/services/schema/feature-page-service.ts